import { observable, computed } from 'mobx';
import { useRequest } from 'ahooks';
import { useEffect, useRef } from 'react';
import BGMStore from '@src/business-components/bgm/store';
import copy from '@src/components/copy';
import { autobind } from 'core-decorators';
import FollowUsModalStore from '@src/business-components/modals/follow-us/store';
import { useHistory } from 'react-router-dom';
import { aLink } from '@src/utils/common-util';
import { jumpPage } from '@src/utils/common-util';
import goToShare from '@src/utils/share';
import Service from './service';
import Toast from '@src/business-components/common-message';
import SelectStore from '@src/business-components/common-language-select/store';
import { SHARE_METHOD_CONFIG } from './config';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import GiftPackModal from '@src/business-components/giftPack-modal';
import GiftPackModalStore from '@src/business-components/giftPack-modal/store';
import useModal from '@src/utils/hooks/use-modal';

const lang = getLanguageByPath();
const pageLocalesData = getPageLocalesData();

class TopMenuStore {
  // 关注我们
  followUsModalStore = new FollowUsModalStore({});

  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: item.img,
        onClick: item.onClick
      }));
  }
  // 是否暂停播放
  @observable userName = '';
  // 是否暂停播放
  @observable isPause = true;
  // 打开菜单
  @observable menuState = false;

  // 二级菜单状态-游戏介绍
  @observable secondaryMenuState1 = false;
  //  二级菜单状态-FAQ
  @observable secondaryMenuState2 = false;
  // 二级菜单状态-社区互动
  // @observable secondaryMenuState3 = false;
  // 二级菜单状态-活动专区
  @observable secondaryMenuState4 = false;
  // 二级菜单状态-礼包直购
  @observable secondaryMenuState5 = false;
  // 二级菜单状态-关注我们
  @observable secondaryMenuState6 = false;

  // 三级级菜单状态-风暴计划
  @observable thirdMenuState2_Item = false;
  // 账号
  @observable login_account = '';
  // 登录状态
  @observable login_status = '';
  @observable $history;

  FAQUrl = {
    en: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/en-US/index',
    ja: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ja-JP/index',
    ko: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ko-KR/index',
    'zh-Hant': 'https://gm-mobile.amazingseasun.com/app/h5/jxj/zh-TW/index',
    es: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/es-ES/index',
    pt: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/pt-PT/index',
    de: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/de-DE/index',
    fr: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/fr-FR/index',
    ru: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/ru-RU/index',
    th: 'https://gm-mobile.amazingseasun.com/app/h5/jxj/th-TH/index'
  };

  CZZUrl = {
    en: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    ja: 'https://mechabreak.seasungames.com/p/m/pre-team/ja/index.html',
    ko: 'https://mechabreak.seasungames.com/p/m/pre-team/ko/index.html',
    'zh-Hant': 'https://mechabreak.seasungames.com/p/m/pre-team/zh-Hant/index.html',
    es: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    pt: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    de: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    fr: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    ru: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html',
    th: 'https://mechabreak.seasungames.com/p/m/pre-team/en/index.html'
  };

  zxph = {
    en: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/en/index.html',
    ja: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/ja/index.html',
    ko: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/ko/index.html',
    'zh-Hant': 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/zh-Hant/index.html',
    es: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/es/index.html',
    pt: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/pt/index.html',
    de: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/de/index.html',
    fr: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/fr/index.html',
    ru: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/ru/index.html',
    th: 'https://mechabreak.seasungames.com/p/m/2025/07/16/styling-ranking/th/index.html'
  };

  selectStore = new SelectStore();

  /**
   * 抢购时间范围
   * @type {{end: *, begin: *}}
   */
  @observable
  timeRange = {
    begin: undefined, // 开始时间
    end: undefined // 结束时间
  };
  /**
   * 售卖状态
   * @type {number} 0-未开始 1-正在售卖 2-售卖结束
   */
  @observable sellStatus = undefined;
  /**
   * 当前时间
   * @type {*}
   */
  @observable currentTime = undefined;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  // 复制PC端链接
  @observable PC_URL = 'https://mechabreak.seasungames.com/p/zt/2025/03/21/market/index.html';

  /**
   * 背景音乐store
   * @type {BGMStore}
   */
  @observable
  bgm = new BGMStore({
    localStoreNameSpace: 'codeBreak-music',
    audioSrc: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1749450843923_BGM_UPGRADE(D)_48k24b.mp3',
    musicPlayIcon: require('./images/music-btn.png'),
    musicPauseIcon: require('./images/music-btn-disable.png'),
    musicIconRotate: false
  });

  /**
   * ssg 登录
   * 当前登录账号
   * @returns {undefined|*}
   */
  @computed
  get currentLoginAccount() {
    return window.XPASS?.$accountStore?.name;
  }

  /**
   *  预约状态/下载状态  1下载 0预约
   */
  @observable is_in_open_download_time;
  /**
   *  登录邮箱/seasun账号（open_down_load为1是seasun账号，为0是登录邮箱号）
   */
  @observable account;

  // 一级菜单展开
  onchangeMenu = menuState => {
    this.menuState = menuState;
  };

  // 二级菜单展开
  @autobind
  openSecondaryMenu(name, i) {
    // 如果点击的是已经打开的栏目，就关闭它
    if (i === 1 && this.secondaryMenuState1) {
      this.secondaryMenuState1 = false;
    } else if (i === 2 && this.secondaryMenuState2) {
      this.secondaryMenuState2 = false;
    } else if (i === 4 && this.secondaryMenuState4) {
      this.secondaryMenuState4 = false;
    } else if (i === 5 && this.secondaryMenuState5) {
      this.secondaryMenuState5 = false;
    } else if (i === 6 && this.secondaryMenuState6) {
      this.secondaryMenuState6 = false;
    } else {
      // 否则关闭所有栏目并打开当前栏目
      this.secondaryMenuState1 = false;
      this.secondaryMenuState2 = false;
      this.secondaryMenuState4 = false;
      this.secondaryMenuState5 = false;
      this.secondaryMenuState6 = false;

      if (i === 1) {
        this.secondaryMenuState1 = true;
      } else if (i === 2) {
        this.secondaryMenuState2 = true;
      } else if (i === 4) {
        this.secondaryMenuState4 = true;
      } else if (i === 5) {
        this.secondaryMenuState5 = true;
      } else if (i === 6) {
        this.secondaryMenuState6 = true;
      }
    }
  }
  maskMiddleFourDigits(number) {
    // 处理空值情况
    if (number == null || number === undefined || number === '') {
      return '';
    }

    const numStr = String(number);
    const length = numStr.length;

    // 处理长度不足 5 的情况（直接全量替换）
    if (length <= 4) {
      return '*'.repeat(length);
    }
    // 计算中间四位的起始位置（动态居中）
    const startIndex = Math.floor((length - 4) / 2);
    const endIndex = startIndex + 4;

    // 拼接结果：前部分 + **** + 后部分
    return numStr.slice(0, startIndex) + '****' + numStr.slice(endIndex);
  }

  // 三级菜单展开
  @autobind
  openthirdMenuMenu(e, name, i) {
    e.stopPropagation();

    // 如果点击的是已经打开的栏目，就关闭它
    if (i === 1 && this.thirdMenuState2_Item) {
      // 检查当前三级菜单状态
      this.thirdMenuState2_Item = false;
    } else {
      // 关闭其他可能打开的三级菜单（如果有）
      this.thirdMenuState2_Item = false;
      // 只在特定条件下打开三级菜单
      if (i === 1 && this.secondaryMenuState1) {
        // 确保二级菜单是打开的
        // console.log(11);
        this.thirdMenuState2_Item = true;
      }
    }
    // console.log(11, this.thirdMenuState2_Item);
  }

  /**
   * 跳转至具体的路由
   * @param {string} url - 跳转路由地址
   * @param {boolean} [isReplace] - 是否替换
   */
  redirect(url, isReplace = false) {
    if (isReplace) {
      this.$history.replace(url);
    } else {
      this.$history.push(url);
    }
  }

  // 跳转路由-方法有问题接入建站后要特殊处理-跳转首页
  toIndex(module) {
    // '/?module=0'
    if (!IS_DEV_ENV) {
      const url = 'index.html';
      jumpPage(url, `#/?module=${module}`);
    } else {
      this.redirect(`/?module=${module}`);
    }
    this.menuState = false;
  }
  // 跳转路由-方法有问题接入建站后要特殊处理-跳转其他路由
  toRouter(path) {
    if (!IS_DEV_ENV) {
      const url = `${path}.html`;
      jumpPage(url, '#/');
    } else {
      this.redirect(`/${path}`);
    }
    this.menuState = false;
  }

  // 跳转外链
  toLink(url) {
    aLink(url);
  }

  /**
   * 跳转链接
   * @param {string} type -  分享变量名
   */
  shareLink(type) {
    goToShare(type);
  }

  // 典藏礼包
  clickGiftPack(text) {
    if (this.sellStatus === 2) {
      Toast.info(`${pageLocalesData.main.eventEnds}`);
    } else {
      copy(this.PC_URL, { successPreText: `${text}` });
    }
  }

  //  SSG登录
  loginClick() {
    sessionStorage.setItem('isLogin', '1');

    window.XPASS.signin();
  }

  /**
   *  公测礼包弹窗
   */
  giftPackModalStore = new GiftPackModalStore({});

  // @autobind
  // async init() {
  //   try {
  //     const res = await this.getConfigRequest.run();
  //     // //console.log('res', res);
  //     this.currentTime = res.reply.current_time;
  //     this.timeRange.begin = res.reply.limited_edition_purchase_range_time.begin;
  //     this.timeRange.end = res.reply.limited_edition_purchase_range_time.end;
  //   } catch (err) {
  //     // //console.log('err:', err);
  //   }
  // }
  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      aLink(url);
    }
  }

  // 退出登录
  @autobind
  onExitBtnClick() {
    if (window.XPASS) {
      window.XPASS?.exit()?.then(() => {
        // 执行退出登录接口
        this.logoutRequest.run();
      });
    }
  }

  use() {
    this.menuRef = useRef(null);
    this.$history = useHistory();

    // 公测礼包弹窗
    this.giftPackModal = useModal(GiftPackModal, {
      store: this.giftPackModalStore
    });

    // 获取礼包配置
    // this.getConfigRequest = useRequest(async () => await Service.getConfig(), {
    //   manual: true
    // });

    // 公测礼包
    // this.gwConfigRequest = useRequest(async () => await Service.gwConfig(), {
    //   manual: true,
    //   onSuccess: res => {
    //     console.log(res, 'res=====');

    //     this.is_in_open_download_time = res?.is_in_open_download_time;
    //     this.account = res?.account;

    //     if (res?.account) {
    //       if (res?.is_in_open_download_time === 1 && res?.is_game_open_get_code_status === 1) {
    //         this.getDownLoadCodeRequest.run();
    //       }
    //     }
    //   },
    //   onError: err => {
    //     const { code, msg } = err.serviceResponse;
    //     if (msg) {
    //       Toast.info(msg);
    //     }
    //   }
    // });

    // 获取下载福利码
    this.getDownLoadCodeRequest = useRequest(async () => await Service.getDownLoadCode(), {
      manual: true,
      onSuccess: res => {
        this.giftPackModalStore.giftCdk = res?.code;
      },
      onError: err => {
        const { code, msg } = err.serviceResponse;
        if (msg) {
          Toast.info(msg);
        }
      }
    });

    // 退出登录态
    this.logoutRequest = useRequest(async () => await Service.logout(), {
      manual: true,
      onSuccess: res => {
        window.location.reload();
      },
      onError: err => {
        const { code, msg } = err.serviceResponse;
        if (msg) {
          Toast.info(msg);
        }
      }
    });

    useEffect(
      () => {
        /**
         * 检查登录状态并处理相关逻辑
         */
        const checkLogin = async () => {
          try {
            if (window.XPASS?.$accountStore?.loginStatus) {
              // await this.gwConfigRequest.run();
              sessionStorage.setItem('isLogin', '0');
            }
          } catch (error) {
            console.error('操作失败:', error);
          }
        };
        // this.init();
        checkLogin();
        this.login_status = window.XPASS?.$accountStore?.loginStatus;
        this.login_account = window.XPASS?.$accountStore?.desensitizationEmail || this.maskMiddleFourDigits(window.XPASS?.$accountStore?.passportId);
      },
      [window.XPASS?.$accountStore?.loginStatus, window.XPASS?.$accountStore?.desensitizationEmail, window.XPASS?.$accountStore?.passportId]
    );
  }
}
export default TopMenuStore;
